"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenplanLayout = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./GenplanLayout.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const GenplanLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isFullscreen,
    controls,
    genplan,
    size,
    filters
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _clsx.default)(styles['layout'], isFullscreen && styles['fixed-container'])
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: size.width,
      maxHeight: size.height,
      height: isFullscreen ? undefined : '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['genplan-container'])
  }, genplan)), controls, filters);
});
exports.GenplanLayout = GenplanLayout;
GenplanLayout.displayName = 'GenplanLayout';